import * as fromColorActions from '../../actions/Componentes/color.actions';


export interface ColorState {
    color: string;
}

const initialStateColor: ColorState = {
    color: 'rgb(4, 51, 73)'
};

export function colorReducer(state = initialStateColor, action: fromColorActions.ColorActions): ColorState {
    switch (action.type) {
        case fromColorActions.SET_COLOR:
            return {
                ...state,
                color: action.color
            };
      default: {
        return state;
      }
    }
}
